module.exports = "/_next/static/images/jm-5e90dbbb2df3198dabf5edabe1f44084.svg";